module.exports = __webpack_public_path__ + "img/start_academy_pl.b9d3ed44.jpg";